import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  // BYPASS AUTH: No localStorage checks, no token validation, always authenticated
  const [isAuthenticated] = useState(true); // Always authenticated
  const [isLoggingOut] = useState(false);

  // No-op logout function
  const logout = () => {
    // Do nothing - bypass auth
  };

  // No-op update function
  const updateAuthState = () => {
    // Do nothing - bypass auth
  };

  const value = {
    isAuthenticated,
    isLoggingOut,
    logout,
    updateAuthState
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
